// @ts-ignore
import React, { useContext, useState } from "react";
// @ts-ignore
import propTypes from "prop-types";

import Context from "../../ContextProvider";

import FormSection from "./FormSection";

function PersonalDetailsForm({ updateSection }) {
  const { form } = useContext<any>(Context);

  const [personalDetailsForm] = form.filter(
    ({ key }) => key === "personalDetails"
  );

  if (!personalDetailsForm) return null;

  // Zustand für das Textfeld hinzufügen
  const [textFieldValue, setTextFieldValue] = useState("");
  const [isTextFieldDisabled, setIsTextFieldDisabled] = useState(true);
  
  const handleCheckboxChange = (idName: string, isChecked: boolean) => {
    console.log(idName);
    if (idName === "sonstigesTextCheck") {
      setIsTextFieldDisabled(!isChecked); // Aktiviert oder deaktiviert das Textfeld
      if (!isChecked) {
        setTextFieldValue(""); // Setzt den Wert des Textfelds zurück
      }
    }
  };

  const handleTextFieldChange = (idName: string, value: string) => {
    if (idName === "sonstigesText") {
      setTextFieldValue(value); // Aktualisiert den Wert des Textfelds
    }
  };
  return (
    // @ts-ignore
    <FormSection
      section={personalDetailsForm}
      updateSection={updateSection}
      onCheckboxChange={handleCheckboxChange}
      onTextFieldChange={handleTextFieldChange}
      textFieldValue={textFieldValue}
      isTextFieldDisabled={isTextFieldDisabled}
    />
  );
}
PersonalDetailsForm.propTypes = {
  updateSection: propTypes.func.isRequired,
};

export default PersonalDetailsForm;
